import classNames from 'classnames';
import React from 'react';
import HashLink from 'components/HashLink';
import { Collapse } from 'components/Transition';
import { language } from 'utils/i18n';
import './style.scss';

interface LangSwitchProps {
    onClick: React.MouseEventHandler;
    showLanguageMenu: boolean;
    className?: string;
}

const LangSwitch: React.FC<LangSwitchProps> = ({ onClick, showLanguageMenu, className }) => {
    return (
        <div className={classNames('lang-switch-root', className)}>
            <HashLink className="dropdown-toggle nav-link" onClick={onClick}>
                {language === 'zh_CN' ? '简' : 'EN'}
            </HashLink>
            <Collapse in={showLanguageMenu}>
                <div className="dropdown-menu show">
                    <a className="dropdown-item" href="?lang=zh_CN">
                        简
                    </a>
                    <div className="dropdown-divider"></div>
                    <a className="dropdown-item" href="?lang=en_US">
                        EN
                    </a>
                </div>
            </Collapse>
        </div>
    );
};

export default LangSwitch;
